import React, { useEffect, useState } from 'react';
import { useMoralis } from 'react-moralis';
import Moralis from 'moralis-v1';
import { IParent } from '../../components/common/types';
import useFetch from '../../utils/hooks/useFetch';

interface IMarketProvider {
	playersCount: string;
	gamesCount: string;
	price: string;
	marketCap: string;
}

export const emptyMarket: IMarketProvider = {
	playersCount: '…',
	gamesCount: '…',
	price: '0.05',
	marketCap: '#####',
};

export const MarketProvider = ({ children }: IParent) => {
	const [playersCount, setPlayersCount] = useState(emptyMarket.playersCount);
	const [gamesCount, setGamesCount] = useState(emptyMarket.gamesCount);
	const [price, setPrice] = useState(emptyMarket.price);
	const [marketCap, setMarketCap] = useState(emptyMarket.marketCap);

	const { isInitialized } = useMoralis();

	const { data: playersCountData } = useFetch(
		`https://metabase.hashup.it/api/public/card/a64b9b24-5837-4f01-b561-9732153aa6ce/query`
	);

	useEffect(() => {
		if (!playersCountData || playersCountData.status !== 'completed') {
			return;
		}

		setPlayersCount(playersCountData.data.rows[0][0]);
	}, [playersCountData]);

	/** A total of games existing and verified */
	useEffect(() => {
		if (isInitialized) {
			(async () => {
				const query = new Moralis.Query('Games').equalTo('listed', true);

				const queryTotal = await query.count();
				setGamesCount(queryTotal as string | any);
			})();
		}
	}, [isInitialized]);

	return (
		<MarketContext.Provider value={{ playersCount, gamesCount, price, marketCap }}>
			{children}
		</MarketContext.Provider>
	);
};

const MarketContext = React.createContext<IMarketProvider>(emptyMarket);

export const useMarketProvider = () => {
	return React.useContext(MarketContext);
};
